import AdminUser from 'AdminUser';

/** Human label for an admin in the "insert admin as email link" picker. */
export function adminLinkLabel(admin: AdminUser): string {
  const name =
    admin.name ||
    [admin.firstName, admin.lastName].filter(Boolean).join(' ') ||
    admin.email ||
    'admin';
  return name.trim();
}
